import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaScroll } from "react-icons/fa";
import SyllabusListItem from "./SyllabusListItem";
import SyllabusDetailPanel from "./SyllabusDetailPanel";
import Loader from "../../../components/Loader/Loader";
import { Link } from "react-router-dom";
import CardHeader from "../../../components/Card/CardHeader";
import Pagination from "../../../components/Pagination/Pagination";
import { enqueueSnackbar } from "notistack";
import { getSyllabuses } from "../../../services/AppManagement/SyllabusService";
import { viewFileFromS3 } from "../../../services/s3Service";
import "./SyllabusList.css";

const SyllabusList = () => {
  const [data, setData] = useState([]);
  const permissions = JSON.parse(localStorage.getItem("permissions"));
  const [isLoader, setIsLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [lastPage, setLastPage] = useState(1);
  const [selectedId, setSelectedId] = useState(null);

  async function fetchSyllabus({ selected = 0 }) {
    const session_id = localStorage.getItem("session_id");
    try {
      setIsLoader(true);
      setCurrentPage(selected);
      const page = selected + 1;
      const response = await getSyllabuses(session_id, page);
      if (response.status === 200) {
        setLastPage(response.data.last_page);
        setData(response.data.data);
        setSelectedId(response.data.data && response.data.data.length > 0 ? response.data.data[0].id : null);
      }
    } catch (error) {
      console.error("API Error:", error.response);
    } finally {
      setIsLoader(false);
    }
  }

  useEffect(() => {
    fetchSyllabus({ selcted: 0 });
  }, []);

  const syllabusDelete = async (id) => {
    try {
      const response = await axios.delete(`/syllabus/${id}`);
      if (response.status === 200) {
        enqueueSnackbar("Syllabus Deleted Successfully", {
          variant: "success",
        });
        fetchSyllabus({ selected: 0 });
      }
    } catch (error) {
      console.error("API Error:", error.response);
    }
  };

  const getFileFromS3 = async (path) => {
    try {
      const response = await viewFileFromS3(path);
      if (response.status === 200) {
        const fileURL = response.data.data.file_url;
        window.open(fileURL, "_blank");
      }
      return response;
    } catch (error) {
      console.error("Error fetching file from S3:", error);
    }
  };

  const selectedSyllabus = data.find((s) => s.id === selectedId) || null;

  return (
    <div className="card">
      <CardHeader
        title="Syllabus List"
        icon={<FaScroll />}
        button={
          permissions.includes("syllabus.create") && (
            <Link to="/syllabus/create" className="btn btn-primary">
              Add Syllabus
            </Link>
          )
        }
      />
      <div className="card-body">
        {isLoader ? (
          <Loader />
        ) : (
          <div className="mt-3">
            {data && data.length > 0 ? (
              <React.Fragment>
                <div className="syllabus-split-view">
                  <div className="syllabus-list-panel">
                    {data.map((syllabus) => (
                      <SyllabusListItem
                        key={syllabus.id}
                        syllabus={syllabus}
                        active={syllabus.id === selectedId}
                        onSelect={(s) => setSelectedId(s.id)}
                        onViewFile={getFileFromS3}
                      />
                    ))}
                  </div>
                  <SyllabusDetailPanel
                    syllabus={selectedSyllabus}
                    permissions={permissions}
                    onDelete={syllabusDelete}
                    onViewFile={getFileFromS3}
                  />
                </div>
                <Pagination
                  totalPage={lastPage}
                  currentPage={currentPage}
                  handlePageChange={(i) => fetchSyllabus(i)}
                ></Pagination>
              </React.Fragment>
            ) : (
              <div className="text-center text-muted">No syllabus found</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default SyllabusList;
